export default __webpack_public_path__ + "2c9163a3c351426bf9eb0867b36daca5.png";